import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  updateCommentsTimestamp,
  updateCommentsTimestampFrozen,
} from 'actions/comments';
import { ENTER, ESCAPE } from 'constants/keyCodes';

import { POSITIVE_INTEGER_REGEX } from 'validate';

import {
  hhMmSsToSeconds,
  secondsToVideoTS,
} from '../../../../../../../shared/utilities/time';

import './styles.less';

const CustomTimeHandler = class extends Component {
  state = {
    editing: false,
    input_val: '',
  };

  render() {
    const {
      commentsEnabled,
      duration,
      timestamp,
      companyFeatureData,
      currentUserIsOwner,
    } = this.props;
    const { brand_primary_color: brandColor } = companyFeatureData || {};
    const { editing, input_val } = this.state;

    const timeStyle =
      brandColor && !currentUserIsOwner
        ? { borderBottom: `1px solid ${brandColor}` }
        : null;

    let commentsDisabledClass = '';

    if (!commentsEnabled) {
      commentsDisabledClass = 'comments-disabled';
    }

    return (
      <div className="time-handler">
        {editing ? (
          <input
            autoFocus
            type="text"
            className="timestamp-edit"
            ref={me => (this.input = me)}
            onBlur={this.validateAndInsertTimestamp}
            onFocus={this.moveCaretAtEnd}
            onKeyDown={this.onKeyDown}
            onChange={this.onChange}
            value={input_val}
            maxLength="8"
          />
        ) : (
          <span
            className={`playback-timestamp ${commentsDisabledClass}`}
            style={timeStyle}
            onClick={this.switchToEditingMode}
          >
            {secondsToVideoTS(timestamp)}
          </span>
        )}
        {duration && (
          <span className="playback-duration">
            {` / ${secondsToVideoTS(Math.round(duration))}`}
          </span>
        )}
      </div>
    );
  }

  moveCaretAtEnd(e) {
    const tempValue = e.target.value;

    e.target.value = '';
    e.target.value = tempValue;
  }

  onChange = e => this.setState({ input_val: e.target.value });

  onKeyDown = e => {
    switch (e.keyCode) {
      case ENTER:
        this.validateAndInsertTimestamp();
        break;
      case ESCAPE:
        this.resetTimestamp();
        break;
      default:
        break;
    }
  };

  resetTimestamp = () => {
    this.setState({ editing: false });
    this.props.updateCommentsTimestampFrozen(false);
  };

  validateAndInsertTimestamp = () => {
    const { duration } = this.props;

    if (this.input == null) {
      return;
    }

    const timestampVal = this.input.value;

    if (POSITIVE_INTEGER_REGEX.test(timestampVal)) {
      if (duration !== null && timestampVal > duration) {
        return this.resetTimestamp();
      }

      this.props.updateCommentsTimestamp(timestampVal);
      this.setState({ editing: false });
    } else {
      try {
        const timestampValInSeconds = hhMmSsToSeconds(this.input.value);

        if (duration !== null && timestampValInSeconds > duration) {
          return this.resetTimestamp();
        }

        this.props.updateCommentsTimestamp(timestampValInSeconds);
        this.setState({ editing: false });
      } catch (e) {
        this.resetTimestamp();
      }
    }
  };

  switchToEditingMode = () => {
    const { timestamp } = this.props;

    this.setState({ input_val: timestamp });
    this.setState({ editing: true });
    this.props.updateCommentsTimestampFrozen(true);
  };
};

const mapStateToProps = state => {
  const {
    time_stamp_frozen: timestampFrozen,
    time_stamp: timestamp,
  } = state.comments;

  const {
    video_properties: { duration },
    comments_enabled: commentsEnabled,
    company_feature_data: companyFeatureData,
  } = state.share_video.video;

  const { current_user_is_owner: currentUserIsOwner } = state.share_video;

  return {
    commentsEnabled,
    duration,
    timestamp,
    timestampFrozen,
    companyFeatureData,
    currentUserIsOwner,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCommentsTimestamp: timestamp =>
      dispatch(updateCommentsTimestamp(timestamp)),
    updateCommentsTimestampFrozen: frozen =>
      dispatch(updateCommentsTimestampFrozen(frozen)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomTimeHandler);
